import React, { useState, useEffect } from 'react'

import Avatar from 'components/common/Avatar'
import { Square } from 'components/common/genericStyles'
import { TOMATO, CUPCAKE } from 'constants/socket'
import { userTypes } from 'constants/user'
import { greetingEventEmitter, greetingKeys } from 'helpers/events'
import useParticipants, {
    getIdentity,
} from 'hooks/useParticipants/useParticipants'

import { Wrapper, AvatarWrapper, squareCustomCss } from './styles'

const FoodSplotchers = props => {
    const { uuid } = props
    const [splotchers, addSplotcher] = useState([])
    const { teacher } = useParticipants()

    const teacherUUID = getIdentity(teacher?.identity)?.uuid

    const actionToTrigger = (props.teacher ? CUPCAKE : TOMATO).toUpperCase()

    useEffect(() => {
        const handleGreeting = greetings => {
            const { sender, reciever } = greetings
            const { uuid } = props
            reciever === uuid &&
                addSplotcher(splotchers => [...splotchers, sender])
        }

        greetingEventEmitter.addListener(
            greetingKeys[actionToTrigger],
            handleGreeting
        )

        return () =>
            greetingEventEmitter.removeListener(
                greetingKeys[actionToTrigger],
                handleGreeting
            )
    }, [])

    const splotchersAvatar = splotchers.map((uuid, i) => {
        const userType =
            teacherUUID === uuid ? userTypes.TEACHER : userTypes.STUDENT

        return (
            <Square.Area key={i} $css={squareCustomCss.area}>
                <Square.Wrapper $css={squareCustomCss.wrapper}>
                    <AvatarWrapper isTeacher={teacherUUID === uuid}>
                        <Avatar uuid={uuid} userType={userType} />
                    </AvatarWrapper>
                </Square.Wrapper>
            </Square.Area>
        )
    })

    return <Wrapper>{splotchersAvatar}</Wrapper>
}

export default FoodSplotchers
